// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CountPhaseController from "./count_phase_controller"
application.register("count-phase", CountPhaseController)

import LotSearchController from "./lot_search_controller"
application.register("lot-search", LotSearchController)

import SearchChipsController from "./search_chips_controller"
application.register("search-chips", SearchChipsController)

import StockTypeController from "./stock_type_controller"
application.register("stock-type", StockTypeController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)
